import React from 'react';

interface SkeletonProps {
  className?: string;
}

/** Пульсирующий серый блок-заглушка */
export const Skeleton: React.FC<SkeletonProps> = ({ className = '' }) => (
  <div className={`animate-pulse bg-gray-200 rounded-lg ${className}`} />
);

/** Skeleton для карточки ресторана в свайпе */
export const SwipeCardSkeleton: React.FC = () => (
  <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
    <Skeleton className="h-48 rounded-none" />
    <div className="p-4 space-y-3">
      <Skeleton className="h-5 w-2/3" />
      <Skeleton className="h-4 w-1/3" />
      <Skeleton className="h-3 w-full" />
      <div className="flex gap-2">
        <Skeleton className="h-6 w-16 rounded-full" />
        <Skeleton className="h-6 w-20 rounded-full" />
      </div>
    </div>
  </div>
);

/** Skeleton для лобби */
export const LobbySkeleton: React.FC = () => (
  <div className="max-w-md mx-auto space-y-6">
    <Skeleton className="h-6 w-24" />
    <Skeleton className="h-8 w-48" />
    <Skeleton className="h-4 w-32" />
    <div className="space-y-3">
      <Skeleton className="h-12 w-full rounded-xl" />
      <Skeleton className="h-12 w-full rounded-xl" />
    </div>
    <div className="space-y-2">
      <Skeleton className="h-10 w-full rounded-xl" />
      <Skeleton className="h-10 w-full rounded-xl" />
      <Skeleton className="h-10 w-full rounded-xl" />
    </div>
    <Skeleton className="h-20 w-full rounded-xl" />
    <Skeleton className="h-14 w-full rounded-2xl" />
  </div>
);

/** Skeleton для страницы результатов */
export const ResultsSkeleton: React.FC = () => (
  <div className="max-w-md mx-auto space-y-4">
    <Skeleton className="h-8 w-40" />
    <Skeleton className="h-4 w-56" />
    <Skeleton className="h-24 w-full rounded-2xl" />
    {[1, 2].map((i) => (
      <div key={i} className="bg-white rounded-2xl overflow-hidden shadow-md">
        <Skeleton className="h-36 rounded-none" />
        <div className="p-4 space-y-2">
          <Skeleton className="h-5 w-2/3" />
          <Skeleton className="h-4 w-1/2" />
          <Skeleton className="h-3 w-full" />
          <div className="flex gap-2">
            <Skeleton className="h-10 flex-1 rounded-xl" />
            <Skeleton className="h-10 flex-1 rounded-xl" />
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default Skeleton;
